
export const ENCRYPTION_KEY = '398h=83y493483sjdkjsbh49h38838==';

export const NAIRA_SIGN = '₦';
